/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 * Rana simulation API (latest stable version: v3)   Framework release: 3.5.63   Rana simulation core release: 3.7.3   deployed on:  08:32AM (UTC) on September 25, 2026
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface UsageStatistics
 */
export interface UsageStatistics {
  /**
   *
   */
  totalSessions: number;
  /**
   *
   */
  totalDuration: number;
  /**
   *
   */
  avgDuration: number;
  /**
   *
   */
  minDuration: number;
  /**
   *
   */
  maxDuration: number;
  /**
   *
   */
  durationHumanized: string;
  /**
   *
   */
  minStarted: Date | null;
  /**
   *
   */
  maxStarted: Date | null;
}

/**
 * Check if a given object implements the UsageStatistics interface.
 */
export function instanceOfUsageStatistics(value: object): value is UsageStatistics {
  if (
    (!("totalSessions" in (value as Record<string, any>)) &&
      !("total_sessions" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["totalSessions"] === undefined &&
      (value as Record<string, any>)["total_sessions"] === undefined)
  )
    return false;
  if (
    (!("totalDuration" in (value as Record<string, any>)) &&
      !("total_duration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["totalDuration"] === undefined &&
      (value as Record<string, any>)["total_duration"] === undefined)
  )
    return false;
  if (
    (!("avgDuration" in (value as Record<string, any>)) &&
      !("avg_duration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["avgDuration"] === undefined &&
      (value as Record<string, any>)["avg_duration"] === undefined)
  )
    return false;
  if (
    (!("minDuration" in (value as Record<string, any>)) &&
      !("min_duration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minDuration"] === undefined &&
      (value as Record<string, any>)["min_duration"] === undefined)
  )
    return false;
  if (
    (!("maxDuration" in (value as Record<string, any>)) &&
      !("max_duration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maxDuration"] === undefined &&
      (value as Record<string, any>)["max_duration"] === undefined)
  )
    return false;
  if (
    (!("durationHumanized" in (value as Record<string, any>)) &&
      !("duration_humanized" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["durationHumanized"] === undefined &&
      (value as Record<string, any>)["duration_humanized"] === undefined)
  )
    return false;
  if (
    (!("minStarted" in (value as Record<string, any>)) &&
      !("min_started" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["minStarted"] === undefined &&
      (value as Record<string, any>)["min_started"] === undefined)
  )
    return false;
  if (
    (!("maxStarted" in (value as Record<string, any>)) &&
      !("max_started" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maxStarted"] === undefined &&
      (value as Record<string, any>)["max_started"] === undefined)
  )
    return false;
  return true;
}

export function UsageStatisticsFromJSON(json: any): UsageStatistics {
  return UsageStatisticsFromJSONTyped(json, false);
}

export function UsageStatisticsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UsageStatistics {
  if (json == null) {
    return json;
  }
  return {
    totalSessions: json["total_sessions"],
    totalDuration: json["total_duration"],
    avgDuration: json["avg_duration"],
    minDuration: json["min_duration"],
    maxDuration: json["max_duration"],
    durationHumanized: json["duration_humanized"],
    minStarted: json["min_started"] == null ? null : parseDateTime(json["min_started"]),
    maxStarted: json["max_started"] == null ? null : parseDateTime(json["max_started"]),
  };
}

export function UsageStatisticsToJSON(json: any): UsageStatistics {
  return UsageStatisticsToJSONTyped(json, false);
}

export function UsageStatisticsToJSONTyped(
  value?: UsageStatistics | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    total_sessions: value["totalSessions"],
    total_duration: value["totalDuration"],
    avg_duration: value["avgDuration"],
    min_duration: value["minDuration"],
    max_duration: value["maxDuration"],
    duration_humanized: value["durationHumanized"],
    min_started:
      value["minStarted"] == null ? value["minStarted"] : serializeDateTime(value["minStarted"]),
    max_started:
      value["maxStarted"] == null ? value["maxStarted"] : serializeDateTime(value["maxStarted"]),
  };
}
